import { BacksolveSourceRow } from 'api/models/BacksolveSourceRow';

// Persisted rows use their database id; unsaved rows fall back to order, then list index.
export const getSourceRowKey = (row: BacksolveSourceRow, index: number): string => {
  if (row.id != null) {
    return String(row.id);
  }
  if (row.order != null) {
    return `order_${row.order}`;
  }
  return `idx_${index}`;
};

export const getSourceRowCellKey = (fieldAlias: string, row: BacksolveSourceRow, index: number): string =>
  `${fieldAlias}_${getSourceRowKey(row, index)}`;
